import styles from "./StepIcon.module.scss";

interface IStepIcon {
  children: string | React.ReactNode;
  customClass?: string;
}

const StepIcon = ({ children, customClass }: IStepIcon) => {
  return <div className={`${styles.StepIcon} ${customClass}`}>{children}</div>;
};

export default StepIcon;
